module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-presidents-8c5b36bc0954be696e8ee5cb9fc857cf.svg";